import ErrorModalTS from './ErrorModalTS'

export default ErrorModalTS
